<template>
  <section>
    <homepage-top-ad class="homepage-top-ad"></homepage-top-ad>
    <section class="container">
      <section class="index-left">
        <index-data></index-data>
        <swiper
          :swiperLeft="swiperLeft"
          :swiperRight="swiperRight"
        ></swiper>
        <index-tags
          :tags="tags"
          :membertag="membertag"
        ></index-tags>
        <NuxtChild :key="$route.params.type" />
      </section>
      <section class="index-right">
        <nav-top-ad class="nav-top-ad"></nav-top-ad>
        <infiniteDtb class="infiniteDtb"></infiniteDtb>
        <indexNews :indexNews="NewsData"></indexNews>
        <nav-bottom-ad class="nav-bottom-ad"></nav-bottom-ad>
        <!-- <indexColumn :commandList="commandList"></indexColumn> -->
        <Hot-column
          class="hot-column-box"
          :noicon="true"
          :hotColumn="hotColumn"
        ></Hot-column>
        <Hot-article></Hot-article>
        <HotSubject
          :noicon="true"
          class="hot-theme"
          @refresh="refreshSubject"
          ref="hotTheme"
          :hotThemeData="hotThemeData"
          @hotSubject="getHotSubject"
        ></HotSubject>
      </section>
    </section>
  </section>
</template>

<script>
import {
  mapMutations,
  mapGetters,
  mapState,
  mapActions
} from "vuex";
import * as api from "~/api/index";
import indexData from "~/components/index/index-data.vue";
import swiper from "~/components/index/swiper.vue";
import indexTags from "~/components/index/index-tags.vue";
import indexNews from "~/components/index/index-news.vue";
// import indexColumn from "~/components/index/index-column.vue";
import infiniteDtb from "~/components/public/infinite-dtb.vue";
import HotColumn from "~/components/column/hot-column";
import HotArticle from "~/components/public/hot-article";
import HotSubject from "~/components/subject/hot-subject";
import navTopAd from "~/components/ad/nav-top-ad";
import navBottomAd from "~/components/ad/nav-bottom-ad";
import homepageTopAd from "~/components/ad/homepage-top-ad";

export default {
  async asyncData({ app, error, req, store, $axios }) {
    try {
      const headers = req && req.headers;
      let [
        swipers,
        articleList,
        NewsData,
        commandList,
        hotColumn,
        hotThemeData,
        fillData,
        memberTags
      ] = await Promise.all([
        $axios(api.getSwiperArticle()),
        $axios(api.getIndexArticle({ tag: "", page: 1, count: 30 })),
        $axios(api.getNewsData({ createDate: "", count: 6 })),
        $axios(api.getCommandList({ page: 1, count: 8 })),
        $axios(api.getHotColumns({ page: 1, count: 5 })),
        $axios(api.hotTheme({ page: 1, count: 5, headers: headers })),
        $axios(api.getMyFocus({ id: -1, page: 1, isHot: true, headers: headers })),
        $axios(api.vipArticleIndex())
      ]);


      if (hotThemeData && hotThemeData.result && hotThemeData.result.length > 0) {
        if (hotThemeData.result && hotThemeData.result.length < 5) {
          let length = 5 - hotThemeData.result.length;
          let focusItem = fillData && fillData.result ? fillData.result.slice(0, length) : [];
          hotThemeData = [...hotThemeData.result, ...focusItem];
        } else if (hotThemeData.result && hotThemeData.result.length >= 5) {
          hotThemeData = hotThemeData.result.slice(0, 5);
        } else {
          hotThemeData = fillData && fillData.result ? fillData.result.slice(0, 5) : [];
        }
      } else {
        hotThemeData = []
      }
      let swiperRightArticle = swipers && swipers.result ? swipers.result.splice(1, 2) : [];
      let tags = [
        // {
        //   name: "index.tags.information",
        //   value: ""
        // },
        {
          name: "index.tags.deep",
          value: "深度"
        },
        {
          name: "index.tags.hot",
          value: "热点"
        },
        {
          name: "index.tags.new-stock",
          value: "新股"
        },
        {
          name: "index.tags.macro",
          value: "宏观"
        },
        {
          name: "index.tags.hk-stock",
          value: "港股"
        },
        {
          name: "index.tags.strategy",
          value: "策略"
        },
        {
          name: "index.tags.a-stock",
          value: "A股"
        },
        {
          name: "index.tags.us-stock",
          value: "美股"
        },
        {
          name: "index.tags.org",
          value: "机构"
        },
        {
          name: "index.tags.famous",
          value: "名家"
        },
        {
          name: "index.tags.performance",
          value: "业绩会直击"
        }
      ];

      return {
        nomore: false,
        swiperLeft: swipers && swipers.result ? swipers.result : [],
        swiperRight: swiperRightArticle,
        tags: tags,
        articleList: articleList && articleList.result ? articleList.result : [],
        NewsData: NewsData.result,
        commandList: commandList && commandList.result ? commandList.result : [],
        hotColumn: hotColumn && hotColumn.result ? hotColumn.result : [],
        hotThemeData: hotThemeData,
        membertag: memberTags && memberTags.result ? memberTags.result : [],
      };
    } catch (err) {
      console.log(err);
      error({
        statusCode: 404,
        message: "文章不存在"
      });
    }
  },
  data() {
    return {
      page: 1,
      count: 30,
      freeLength: 0,
      memberArticleTime: null
    };
  },
  components: {
    indexData,
    swiper,
    indexTags,
    indexNews,
    // indexColumn,
    infiniteDtb,
    HotColumn,
    HotArticle,
    HotSubject,
    navTopAd,
    navBottomAd,
    homepageTopAd
  },
  computed: {
    ...mapGetters("user", ["isLogin", "userId"])
  },
  methods: {
    refreshSubject() {
      this.getHotSubject();
    },
    async getHotSubject() {
      // let hotThemeData = await this.$axios(
      //   api.hotTheme({
      //     page: 1
      //   })
      // );

      // let fillData = await this.$axios(
      //   api.getMyFocus({
      //     id: -1,
      //     page: 1,
      //     isHot: true
      //   })
      // );
      let [hotThemeData, fillData] = await Promise.all([
        this.$axios(
          api.hotTheme({
            page: 1
          })
        ),
        this.$axios(
          api.getMyFocus({
            id: -1,
            page: 1,
            isHot: true
          })
        )
      ])
      if (hotThemeData && hotThemeData.result && hotThemeData.result.length > 0) {
        if (hotThemeData.result && hotThemeData.result.length < 5) {
          let length = 5 - hotThemeData.result.length;
          let focusItem = fillData && fillData.result ? fillData.result.slice(0, length) : [];
          this.hotThemeData = [...hotThemeData.result, ...focusItem];
        } else if (hotThemeData.result && hotThemeData.result.length >= 5) {
          this.hotThemeData = hotThemeData.result.slice(0, 5);
        } else {
          this.hotThemeData = fillData && fillData.result ? fillData.result.slice(0, 5) : []
        }
      } else {
        this.hotThemeData = []
      }

    },
    async getTagArticle(i) {
      this.page = 1;
      this.articleList = [];
      this.nomore = false;
      if (i === "会员专享") {
        this.getResearchReport(i);
        return;
      }
      let result = await this.$axios(
        api.getIndexArticle({
          tags: i,
          page: this.page,
          count: this.count
        })
      );
      this.articleList = result && result.result ? result.result : [];
    },
    async getMoreArticle(i) {
      this.page++;
      let result = await this.$axios(
        api.getIndexArticle({
          tags: i,
          page: this.page,
          count: this.count
        })
      );
      this.nomore = result.result ? false : true;
      this.articleList = [...this.articleList, ...result.result];
    },
    async getResearchReport(i) {
      let article = await this.$axios(api.vipArticleListAll({
        loaded: 15,
        timestamp: this.memberArticleTime
      }));
      this.nomore = article.result.length < 15 ? false : true;
      this.memberArticleTime = article.result[article.result.length - 1].contents.timestamp - 1
      this.articleList = [...this.articleList, ...article.result];
    }
  },
  head() {
    return {
      link: [
        {
          rel: "canonical",
          href: "https://www.gelonghui.com/"
        },
        {
          rel: "alternate",
          media: "only screen and (max-width:640px)",
          href: "https://m.gelonghui.com/"
        }
      ]
    };
  }
};
</script>

<style lang="less">
.container {
  min-height: 100vh;
  width: 1200px;
  margin: 0px auto;
  margin-top: 20px;
  padding-bottom: 80px;
  display: flex;
  justify-content: space-between;

  .index-left {
    width: 852px;
    height: auto;
  }

  .index-right {
    width: 328px;
    position: relative;
    .nav-top-ad {
      margin-bottom: 15px;
    }
    .nav-bottom-ad {
      margin-bottom: 20px;
      margin-top: 20px;
    }
    .hot-column-box {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .hot-theme {
      margin-top: 20px;
      position: sticky !important;
      top: 110px;
      width: 100% !important;
    }
  }
}
</style>
